var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultichoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 18.8333C5.39795 18.8333 1.66699 15.1023 1.66699 10.5C1.66699 5.89758 5.39795 2.16663 10.0003 2.16663C14.6027 2.16663 18.3337 5.89758 18.3337 10.5C18.3337 15.1023 14.6027 18.8333 10.0003 18.8333ZM10.0003 13.8333C11.8412 13.8333 13.3337 12.3409 13.3337 10.5C13.3337 8.65901 11.8412 7.16663 10.0003 7.16663C8.15937 7.16663 6.66699 8.65901 6.66699 10.5C6.66699 12.3409 8.15937 13.8333 10.0003 13.8333Z",
    fill: "#0A0A0A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultichoice);
export default __webpack_public_path__ + "static/media/multichoice.2328c6da0aba8a47555cb4850b4731a5.svg";
export { ForwardRef as ReactComponent };